import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IAssessScreen } from '../models/assessScreen';
import { ErrorService } from '../helpers/errorService';

@Injectable({
  providedIn: 'root'
})
export class AssessScreenService {

    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getAssessScreenByCaseId(caseId: string): Observable<IAssessScreen> {
        const url = environment.apiBaseUrl + endpoints.getAssessScreenByCaseId.replace(':caseId', caseId);
        return this.http.get<IAssessScreen>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateAssessScreen(data: IAssessScreen): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateAssessScreen;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

}